"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureYourPerimeter() {
  const {
    ref: word1Ref,
    isVisible: word1Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: word2Ref,
    isVisible: word2Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: word3Ref,
    isVisible: word3Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="3501" id="secure-your-perimeter" className="relative bg-background text-foreground overflow-hidden py-24 md:py-40 lg:py-[200px] px-6 md:px-12 lg:px-20">
      {}
      <div className="hidden md:block absolute left-6 top-1/2 -translate-y-1/2 z-10">
        {}
      </div>

      <div className="hidden md:block absolute right-0 top-0 bottom-0 w-[2px] z-10" style={{
      background: "var(--primary)",
      boxShadow: "0 0 40px 8px var(--primary)"
    }} aria-hidden="true" />

      <div className="md:hidden absolute left-0 right-0 top-0 h-[2px] z-10" style={{
      background: "var(--primary)",
      boxShadow: "0 0 40px 4px var(--primary)"
    }} aria-hidden="true" />

      <div className="relative max-w-[1440px] mx-auto">
        <div className="flex flex-col items-center gap-12 lg:gap-20">
          {}
          <div className="w-full">
            <h2 className="font-default font-extrabold uppercase leading-[0.9] text-foreground text-[56px] sm:text-[80px] md:text-[110px] lg:text-[140px] text-center" style={{
            letterSpacing: "-0.04em"
          }}>
              <span ref={word1Ref} data-index={0} className="block transition-all duration-700 ease-out" style={{
              opacity: word1Visible ? 1 : 0,
              transform: word1Visible ? "translateY(0)" : "translateY(40px)",
              transitionDelay: "0ms"
            }}>DEPLOY&nbsp;</span>
              <span ref={word2Ref} data-index={1} className="block transition-all duration-700 ease-out" style={{
              opacity: word2Visible ? 1 : 0,
              transform: word2Visible ? "translateY(0)" : "translateY(40px)",
              transitionDelay: "200ms"
            }}>YOUR&nbsp;</span>
              <span ref={word3Ref} data-index={2} className="block transition-all duration-700 ease-out" style={{
              opacity: word3Visible ? 1 : 0,
              transform: word3Visible ? "translateY(0)" : "translateY(40px)",
              transitionDelay: "400ms"
            }}>
                AUTOPILOT
                <span className="inline-block align-baseline" style={{
                color: "var(--primary)",
                fontSize: "1.3em",
                lineHeight: 0
              }}>.</span>
              </span>
            </h2>
          </div>

          {}
          <div className="flex justify-center w-full">
            <div ref={cardRef} className="w-full max-w-[540px] p-8 md:p-10 border border-border backdrop-blur-sm transition-all duration-700 ease-out shadow-lg" style={{
            backgroundColor: "var(--card)",
            opacity: cardVisible ? 1 : 0,
            transform: cardVisible ? "translateY(0)" : "translateY(40px)",
            transitionDelay: "600ms"
          }}>
              <div className="font-mono text-[11px] uppercase tracking-[0.2em] mb-6" style={{
              color: "var(--primary)"
            }}>TACTICAL SERVICES</div>

              <p className="font-default font-normal text-base md:text-lg leading-relaxed text-foreground/90 mb-8">Stop missing calls and start scaling. We integrate 24/7 AI answering, custom web design, and branding to put your business on autopilot.</p>

              <Button className="w-full h-14 uppercase font-default font-bold text-sm tracking-[0.15em] shadow-md hover:opacity-90 transition-opacity rounded-lg" style={{
              backgroundColor: "var(--primary)",
              color: "var(--primary-foreground)"
            }}>
                MISSION BRIEF
                <ArrowRight className="ml-2 size-4" />
              </Button>

              
            </div>
          </div>
        </div>
      </div>
    </section>;
}